import React, { createContext, useContext, useEffect, useState, useMemo } from "react";

const OnboardingContext = createContext(null);
const DRAFT_KEY = "qhearts-onboarding-draft-v1";
const SESSION_KEY = "qhearts-profile-id";

const EMPTY = {
  email: "",
  name: "",
  gender: "",
  birth_date: "",
  interested_in: [],
  relationship_type: "",
  height_cm: null,
  children_status: "",
  family_plans: "",
  faith: "",
  interests: [],
  traits: [],
  profession: "",
  lifestyle: "",
  education: "",
  smoking: "",
  alcohol: "",
  city: "",
  zip_code: "",
  bio: "",
  legal_first_name: "",
  legal_last_name: "",
  photos: [],
  selfie: null,
  verification_status: "not_started",
  // local-only
  acknowledged_intro: false,
};

const STEP_COUNT = 31;

export function OnboardingProvider({ children }) {
  const [data, setData] = useState(() => {
    try {
      const raw = localStorage.getItem(DRAFT_KEY);
      return raw ? { ...EMPTY, ...JSON.parse(raw) } : EMPTY;
    } catch {
      return EMPTY;
    }
  });
  const [step, setStep] = useState(1);

  useEffect(() => {
    try {
      localStorage.setItem(DRAFT_KEY, JSON.stringify(data));
    } catch (err) {
      console.warn("Onboarding draft konnte nicht gespeichert werden:", err);
    }
  }, [data]);

  const update = (patch) => setData((p) => ({ ...p, ...patch }));

  const next = () => setStep((s) => Math.min(STEP_COUNT, s + 1));
  const back = () => setStep((s) => Math.max(1, s - 1));
  const goto = (n) => setStep(Math.max(1, Math.min(STEP_COUNT, n)));

  const reset = () => {
    setData(EMPTY);
    setStep(1);
    try {
      localStorage.removeItem(DRAFT_KEY);
    } catch (err) {
      console.warn("Onboarding draft konnte nicht gelöscht werden:", err);
    }
  };

  const saveProfileId = (id) => {
    try {
      localStorage.setItem(SESSION_KEY, id);
    } catch (err) {
      console.warn("Profil-ID konnte nicht gespeichert werden:", err);
    }
  };

  const value = useMemo(
    () => ({ data, update, step, next, back, goto, reset, saveProfileId, STEP_COUNT }),
    [data, step]
  );

  return <OnboardingContext.Provider value={value}>{children}</OnboardingContext.Provider>;
}

export function useOnboarding() {
  const ctx = useContext(OnboardingContext);
  if (!ctx) throw new Error("useOnboarding must be used within OnboardingProvider");
  return ctx;
}

export function getSessionProfileId() {
  try {
    return localStorage.getItem(SESSION_KEY) || null;
  } catch {
    return null;
  }
}

export function setSessionProfileId(id) {
  try {
    if (id) localStorage.setItem(SESSION_KEY, id);
    else localStorage.removeItem(SESSION_KEY);
  } catch (err) {
    console.warn("Sitzung konnte nicht aktualisiert werden:", err);
  }
}
